import React, { useState, useRef, useCallback, useEffect } from 'react';
import {
    Card,
    Grid,
    TextField,
    Box,
    MenuItem,
    Button,
    Typography, IconButton, FormControl, FormHelperText
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { DataGrid } from '@mui/x-data-grid';
import { Edit, Delete } from '@mui/icons-material';
import { useFormik } from "formik";
import * as Yup from "yup";
import communicationApi from '../../../../services/communication'
import { showLoader, hideLoader } from "../../../../redux/loader/actions";
import { showSnackbar } from "../../../../redux/snackbar/actions";
import { useDispatch } from "react-redux";


const Communication = () => {
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const [communicationTypes, setCommunicationTypes] = useState([]);
    const [communicationTypesPlan, setCommunicationTypesPlan] = useState([]);
    const [communicatiolistRows, setCommunicatiolistRows] = useState([]);
    const [editId, setEditId] = useState(null);
    const [paginationModel, setPaginationModel] = useState({
        page: 1,
        pageSize: 1000,
    });
    const getAllCommunicationType = useCallback(() => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            console.log('API response:', res);
            const types = Array.isArray(res?.data?.data) ? res.data.data : [];
            setCommunicationTypes(types);
            dispatch(hideLoader());
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch communication types', err);
        };

        communicationApi.getAllCommunicationType().then(onSuccess, onFailure);
    }, []);

    useEffect(() => {
        getAllCommunicationType();
    }, [getAllCommunicationType]);


    const getAllCommunicationPlan = useCallback(() => {
        dispatch(showLoader());

        const onSuccess = (res) => {
            console.log('plans', res);
            const plans = Array.isArray(res?.data?.data)
                ? res.data.data.map((plan) => ({
                    label: plan.plan_name,
                    uuid: plan.plan_uuid
                }))
                : [];

            setCommunicationTypesPlan(plans);
            dispatch(hideLoader());
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error('Failed to fetch communication types', err);
        };

        communicationApi.getAllCommunicationPlan(paginationModel.page, paginationModel.pageSize)
            .then(onSuccess, onFailure);

    }, [paginationModel.page, paginationModel.pageSize, dispatch]);

    useEffect(() => {
        getAllCommunicationPlan();
    }, [getAllCommunicationPlan]);

    const [newlyCreatedPlanUUID, setNewlyCreatedPlanUUID] = useState(null);

    const newplan = useCallback((planName) => {
        dispatch(showLoader());

        communicationApi.getAllCommunicationPlan(1, 1000).then((res) => {
            const plans = Array.isArray(res?.data?.data) ? res.data.data : [];

            const highestPlanOrder = Math.max(...plans.map(plan => plan.plan_order), 0);
            const nextPlanOrder = highestPlanOrder + 1;

            const data = {
                plan_name: planName,
                plan_order: nextPlanOrder,
            };

            communicationApi.createCommunicationPlancreate(data).then(
                (res) => {
                    const newPlanUUID = res?.data?.data?.plan_uuid;
                    setNewlyCreatedPlanUUID(newPlanUUID); // <-- add this
                    formik.setFieldValue('plan', newPlanUUID);

                    console.log('de', res?.data?.data?.plan_uuid);
                    dispatch(hideLoader());
                    dispatch(
                        showSnackbar({
                            message: res?.data?.msg,
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "right",
                            },
                            variant: "success",
                        })
                    );
                    const newPlan = {
                        label: planName,
                        uuid: res?.data?.data?.uuid,
                    };

                    setCommunicationTypesPlan(prevPlans => [...prevPlans, newPlan]);
                    getAllCommunicationPlan();
                },
                (err) => {
                    dispatch(hideLoader());
                    dispatch(
                        showSnackbar({
                            message: err?.response?.data?.msg || 'Failed to create plan',
                            autoHideDuration: 3000,
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "right",
                            },
                            variant: "error",
                        })
                    );
                }
            );
        }).catch((err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg || 'Failed to fetch existing plans',
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "error",
                })
            );
        });
    }, [dispatch, getAllCommunicationPlan]);

    const handleSubmit = useCallback((formData) => {
        dispatch(showLoader());
        const data = {
            communication_type_uuid: formData.communicationType,
            plan_uuid: newlyCreatedPlanUUID || formData.plan,
            frequency: formData.frequency,
            per_credit: formData.perCredit ? parseInt(formData.perCredit, 10) : undefined,

        };
        const onSuccess = (res) => {
            dispatch(hideLoader()); dispatch(
                showSnackbar({
                    message: res?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "success",
                })
            );
            setEditId(null);
            getProductMapping()
            formik.resetForm();
        };
        const onFailure = (err) => {
            dispatch(hideLoader()); dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "error",
                })
            );
        };

        if (editId) {
            communicationApi.communicationProductMappingEdit(editId, data).then(onSuccess, onFailure);
        } else {
            communicationApi.communicationProductMappingcreate(data).then(onSuccess, onFailure);
        }

    }, [dispatch, editId]);


    const formik = useFormik({
        initialValues: {
            communicationType: '',
            plan: '',
            frequency: [],
            perCredit: ''
        },
        validationSchema: Yup.object({
            communicationType: Yup.string().required("Communication Type is required"),
            plan: Yup.string().required("Plan is required"),
            frequency: Yup.array().min(1, "At least one frequency is required"),
            perCredit: Yup.mixed()
                .required("Per Credit is required")
                .transform((val) => (val ? parseInt(val, 10) : NaN))
                .test(
                    "is-valid-credit",
                    "Must be divisible by 50, min 50 and max 1 crore",
                    (val) => {
                        return !isNaN(val) && val % 50 === 0 && val >= 50 && val <= 100000000;
                    }
                )

        }),
        onSubmit: handleSubmit,
    });


    const frequencyOptions = ["monthly", "quarterly", "halfyearly", "yearly", "unlimited"];

    const columns = [
        { field: "sno_id", headerName: "S.No", align: "center", headerAlign: "center", width: 80 },
        { field: "communicationtype", headerName: "Communication Type", align: "center", headerAlign: "center", flex: 1 },
        { field: "plan", headerName: "Plan", align: "center", headerAlign: "center", flex: 1 },
        { field: "frequency", headerName: "Frequency", align: "center", headerAlign: "center", flex: 1 },
        { field: "percredit", headerName: "Per Credit", align: "center", headerAlign: "center", flex: 1 },
        {
            field: "actions",
            headerName: "Actions",
            align: "center",
            headerAlign: "center",
            width: 120,
            renderCell: (params) => (
                <>
                    <IconButton color="primary" onClick={() => handleEdit(params.row)}>
                        <Edit />
                    </IconButton>
                    <IconButton color="primary" onClick={() => handleDelete(params.id)}>
                        <Delete />
                    </IconButton>
                </>
            ),
        }
    ];

    const getProductMapping = useCallback(() => {
        dispatch(showLoader());

        const onSuccess = (res) => {
            const rawData = res?.data?.data || [];
            const rows = formatCommunicationRows(rawData);
            setCommunicatiolistRows(rows);
            dispatch(hideLoader());
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            console.error("Failed to fetch communication types", err);
        };

        communicationApi.getcommunicationProductMapping().then(onSuccess, onFailure);
    }, [dispatch]);

    useEffect(() => {
        getProductMapping();
    }, [getProductMapping]);


    const formatCommunicationRows = (data) => {
        return data.map((item, index) => ({
            id: item?.product_plan_mapping_uuid,
            sno_id: index + 1,
            product_plan_mapping_uuid: item?.product_plan_mapping_uuid,
            communicationtype: item?.communicationType?.communication_type || "-",
            plan: item?.productPlan?.plan_name || "-",
            frequency: Array.isArray(item?.frequency)
                ? item.frequency.map(f => f.charAt(0).toUpperCase() + f.slice(1)).join(", ")
                : "-",
            percredit: item?.per_credit?.toString() || "-",
        }));
    };

    const handleEdit = (row) => {
        console.log("Editing row:", row);

        formik.setValues({
            communicationType: communicationTypes.find(type => type.communication_type === row.communicationtype)?.communication_type_uuid || '',
            plan: communicationTypesPlan.find(plan => plan.label === row.plan)?.uuid || '',
            frequency: row.frequency.split(", ").map(freq => freq.toLowerCase()),
            perCredit: row.percredit !== "-" ? row.percredit : '',
        });
        setEditId(row.product_plan_mapping_uuid);

    };


    const handleDelete = (id) => {
        console.log("Delete clicked for ID:", id);

        dispatch(showLoader());
        const onSuccess = (res) => {
            console.log("Delete Success:", res);
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: res?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "success",
                })
            );
            getProductMapping();
        };


        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                    },
                    variant: "error",
                })
            );
        };
        communicationApi.communicationProductMappingDelete(id).then(onSuccess, onFailure);
    };

    return (
        <Box sx={{ p: 2 }}>
            <Card elevation={3} sx={{ p: 3, mb: 2 }}>
                <Typography sx={{ mb: 2, color: '#a00', fontSize: '20px', fontWeight: '600' }}>
                    Communication Channel
                </Typography>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            select
                            label="Communication type"
                            name="communicationType"
                            value={formik.values.communicationType}
                            onChange={(e) => {
                                const selectedUuid = e.target.value;
                                formik.setFieldValue("communicationType", selectedUuid);
                                console.log("Selected UUID:", selectedUuid);
                            }}

                            onBlur={formik.handleBlur}
                            error={formik.touched.communicationType && Boolean(formik.errors.communicationType)}
                            helperText={
                                formik.touched.communicationType && formik.errors.communicationType
                                    ? formik.errors.communicationType
                                    : " "
                            }

                        >
                            {communicationTypes.map((type) => (
                                <MenuItem
                                    key={type.communication_type_uuid}
                                    value={type.communication_type_uuid}
                                >
                                    {type.communication_type.charAt(0).toUpperCase() + type.communication_type.slice(1).toLowerCase()}
                                </MenuItem>

                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth error={formik.touched.plan && Boolean(formik.errors.plan)}>
                            <Autocomplete
                                freeSolo
                                options={communicationTypesPlan}
                                getOptionLabel={(option) =>
                                    option.label
                                        ? option.label.charAt(0).toUpperCase() + option.label.slice(1).toLowerCase()
                                        : ''
                                }
                                value={
                                    communicationTypesPlan.find((opt) => opt.uuid === formik.values.plan) ||
                                    { label: formik.values.plan, uuid: '' }
                                }
                                onChange={(e, newValue) => {
                                    if (typeof newValue === 'string') {
                                        formik.setFieldValue("plan", newValue);
                                        newplan(newValue, newValue);
                                    } else if (newValue && newValue.inputValue) {
                                        formik.setFieldValue("plan", newValue.inputValue);
                                        newplan(newValue.inputValue, newValue.inputValue);
                                    } else {
                                        formik.setFieldValue("plan", newValue?.uuid || '');
                                    }
                                }}

                                // filterOptions={(options, params) => {
                                //     const filtered = options.filter((opt) =>
                                //         opt.label.toLowerCase().includes(params.inputValue.toLowerCase())
                                //     );

                                //     if (params.inputValue !== '') {
                                //         filtered.push({
                                //             inputValue: params.inputValue,
                                //             label: `Add "${params.inputValue}"`,
                                //         });
                                //     }

                                //     return filtered;
                                // }}
                                filterOptions={(options, params) => {
                                    const filtered = options.filter((opt) =>
                                        opt.label.toLowerCase().includes(params.inputValue.toLowerCase())
                                    );

                                    if (params.inputValue !== '') {
                                        const capitalizedInput =
                                            params.inputValue.charAt(0).toUpperCase() + params.inputValue.slice(1).toLowerCase();

                                        filtered.push({
                                            inputValue: params.inputValue,
                                            label: `Add "${capitalizedInput}"`,
                                        });
                                    }

                                    return filtered;
                                }}

                                selectOnFocus
                                clearOnBlur
                                handleHomeEndKeys
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="plan"
                                        label="Plan"
                                        onBlur={formik.handleBlur}
                                    />
                                )}
                            />
                            <FormHelperText>
                                {formik.touched.plan && formik.errors.plan ? formik.errors.plan : " "}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth error={formik.touched.frequency && Boolean(formik.errors.frequency)}>
                            <Autocomplete
                                multiple
                                options={frequencyOptions}
                                value={formik.values.frequency}
                                onChange={(e, value) => formik.setFieldValue('frequency', value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Frequency"
                                        name="frequency"
                                        placeholder="Select Frequency"
                                        onBlur={formik.handleBlur}
                                    />
                                )}
                            />
                            <FormHelperText>
                                {formik.touched.frequency && formik.errors.frequency ? formik.errors.frequency : " "}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth error={formik.touched.perCredit && Boolean(formik.errors.perCredit)}>
                            <TextField
                                fullWidth
                                name="perCredit"
                                label="Per Credit"
                                type="text"
                                value={formik.values.perCredit}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, "");
                                    formik.setFieldValue("perCredit", val);
                                }}
                                onBlur={formik.handleBlur}
                            // error={formik.touched.perCredit && Boolean(formik.errors.perCredit)}
                            // helperText={formik.touched.perCredit ? formik.errors.perCredit : " "}
                            />

                            <FormHelperText>
                                {formik.touched.perCredit && formik.errors.perCredit ? formik.errors.perCredit : " "}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={formik.handleSubmit}
                        >
                            {editId ? "Update" : "Add"}
                        </Button>
                    </Grid>
                </Grid>
            </Card>
            <Card elevation={3} sx={{ p: 2, mt: 2 }}>
                <Box sx={{  }}>
                    <DataGrid
                        rows={communicatiolistRows}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5, 10, 20]}
                    />
                </Box>
            </Card>

        </Box>
    );
};

export default Communication;
